import defaultClusterIcon from '../assets/mapIcons/cluster/default';
import largestClusterIcon from '../assets/mapIcons/cluster/largest';

import placeActiveIcon from '../assets/mapIcons/common/place/active.svg';

import commonSelectedOnRouteIcon from '../assets/mapIcons/stations/common/selected.svg';
import discountSelectedOnRouteIcon from '../assets/mapIcons/stations/discount/selected.svg';
import powerMaxSelectedOnRouteIcon from '../assets/mapIcons/stations/powerMax/selected.svg';

import commonStationIcon from '../assets/mapIcons/stations/common/default.svg';
import commonFavouriteStationIcon from '../assets/mapIcons/stations/common/favourite.png';
import commonActiveStationIcon from '../assets/mapIcons/stations/common/active.svg';
import commonActiveFavouriteStationIcon from '../assets/mapIcons/stations/common/activeFavourite.svg';

import discountStationIcon from '../assets/mapIcons/stations/discount/default.svg';
import discountFavouriteStationIcon from '../assets/mapIcons/stations/discount/favourite.png';
import discountActiveStationIcon from '../assets/mapIcons/stations/discount/active.svg';
import discountActiveFavouriteStationIcon from '../assets/mapIcons/stations/discount/activeFavourite.svg';

import powerMaxStationIcon from '../assets/mapIcons/stations/powerMax/default.svg';
import powerMaxFavouriteStationIcon from '../assets/mapIcons/stations/powerMax/favourite.png';
import powerMaxActiveStationIcon from '../assets/mapIcons/stations/powerMax/active.svg';
import powerMaxActiveFavouriteStationIcon from '../assets/mapIcons/stations/powerMax/activeFavourite.svg';

import economyStationIcon from '../assets/mapIcons/stations/economy/default.svg';
import economyFavouriteStationIcon from '../assets/mapIcons/stations/economy/favourite.png';
import economyActiveStationIconfrom from  '../assets/mapIcons/stations/economy/active.svg';
import economyActiveFavouriteStationIconfrom from  '../assets/mapIcons/stations/economy/activeFavourite.svg';

// Roadside services
import roadPaymentPointServiceIcon from '../assets/mapIcons/roadsideServices/roadPaymentPoint/default.svg';
import roadPaymentPointServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/roadPaymentPoint/favourite.png';
import roadPaymentPointActiveServiceIcon from  '../assets/mapIcons/roadsideServices/roadPaymentPoint/active.svg';
import roadPaymentPointSelectedServiceIcon from '../assets/mapIcons/roadsideServices/roadPaymentPoint/selected.svg';
import roadPaymentPointActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/roadPaymentPoint/activeFavourite.svg';

import parkingServiceIcon from '../assets/mapIcons/roadsideServices/parking/default.svg';
import parkingServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/parking/favourite.png';
import parkingActiveServiceIcon from  '../assets/mapIcons/roadsideServices/parking/active.svg';
import parkingSelectedServiceIcon from '../assets/mapIcons/roadsideServices/parking/selected.svg';
import parkingActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/parking/activeFavourite.svg';

import carWashServiceIcon from '../assets/mapIcons/roadsideServices/carWash/default.svg';
import carWashServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/carWash/favourite.png';
import carWashActiveServiceIcon from  '../assets/mapIcons/roadsideServices/carWash/active.svg';
import carWashSelectedServiceIcon from '../assets/mapIcons/roadsideServices/carWash/selected.svg';
import carWashActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/carWash/activeFavourite.svg';

import carServiceServiceIcon from '../assets/mapIcons/roadsideServices/carService/default.svg';
import carServiceServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/carService/favourite.png';
import carServiceActiveServiceIcon from  '../assets/mapIcons/roadsideServices/carService/active.svg';
import carServiceSelectedServiceIcon from '../assets/mapIcons/roadsideServices/carService/selected.svg';
import carServiceActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/carService/activeFavourite.svg';

import convoyServiceIcon from '../assets/mapIcons/roadsideServices/convoy/default.svg';
import convoyServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/convoy/favourite.png';
import convoyActiveServiceIcon from  '../assets/mapIcons/roadsideServices/convoy/active.svg';
import convoySelectedServiceIcon from '../assets/mapIcons/roadsideServices/convoy/selected.svg';
import convoyActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/convoy/activeFavourite.svg';

import ferryboatServiceIcon from '../assets/mapIcons/roadsideServices/ferryboat/default.svg';
import ferryboatServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/ferryboat/favourite.png';
import ferryboatActiveServiceIcon from  '../assets/mapIcons/roadsideServices/ferryboat/active.svg';
import ferryboatSelectedServiceIcon from '../assets/mapIcons/roadsideServices/ferryboat/selected.svg';
import ferryboatActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/ferryboat/activeFavourite.svg';

import railwayServiceIcon from '../assets/mapIcons/roadsideServices/railway/default.svg';
import railwayServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/railway/favourite.png';
import railwayActiveServiceIcon from  '../assets/mapIcons/roadsideServices/railway/active.svg';
import railwaySelectedServiceIcon from '../assets/mapIcons/roadsideServices/railway/selected.svg';
import railwayActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/railway/activeFavourite.svg';

import autoPartsStoreServiceIcon from '../assets/mapIcons/roadsideServices/autoPartsStore/default.svg';
import autoPartsStoreServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/autoPartsStore/favourite.png';
import autoPartsStoreActiveServiceIcon from '../assets/mapIcons/roadsideServices/autoPartsStore/active.svg';
import autoPartsStoreSelectedServiceIcon from '../assets/mapIcons/roadsideServices/autoPartsStore/selected.svg';
import autoPartsStoreActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/autoPartsStore/activeFavourite.svg';

import cafeServiceIcon from '../assets/mapIcons/roadsideServices/cafe/default.svg';
import cafeServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/cafe/favourite.png';
import cafeActiveServiceIcon from  '../assets/mapIcons/roadsideServices/cafe/active.svg';
import cafeSelectedServiceIcon from '../assets/mapIcons/roadsideServices/cafe/selected.svg';
import cafeActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/cafe/activeFavourite.svg';

import truckWashServiceIcon from '../assets/mapIcons/roadsideServices/truckWash/default.svg';
import truckWashServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/truckWash/favourite.png';
import truckWashActiveServiceIcon from  '../assets/mapIcons/roadsideServices/truckWash/active.svg';
import truckWashSelectedServiceIcon from '../assets/mapIcons/roadsideServices/truckWash/selected.svg';
import truckWashActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/truckWash/activeFavourite.svg';

import {
  MARKER_HEIGHT,
  ACTIVE_MARKER_HEIGHT,
  ACTIVE_MARKER_WIDTH,
  CLUSTER_HEIGHT,
  CLUSTER_WIDTH,
  LARGEST_CLUSTER_HEIGHT,
  LARGET_CLUSTER_WIDTH,
  MARKER_WIDTH
} from '../constants';


export const getMarkerSettings = (iconURL: string, id?: string) => () => ({
  url: iconURL,
  height: MARKER_HEIGHT,
  width: MARKER_WIDTH,
  anchorY: MARKER_HEIGHT,
  anchorX: MARKER_WIDTH * 0.5,
  id
});

export const getMarkerSelectedSettings = (iconURL: string, id?: string) => () => ({
  url: iconURL,
  height: MARKER_HEIGHT,
  width: MARKER_WIDTH,
  anchorY: MARKER_HEIGHT,
  anchorX: MARKER_WIDTH * 0.5,
  id
});

export const getActiveMarkerSettings = (iconURL: string, id?: string) => () => ({
  url: iconURL,
  height: ACTIVE_MARKER_HEIGHT,
  width: ACTIVE_MARKER_WIDTH * 0.75,
  anchorY: ACTIVE_MARKER_HEIGHT,
  anchorX: ACTIVE_MARKER_WIDTH * 0.375,
  id
});

export const getClusterSettings = () => ({ clusterWeight }: any) => ({
  url: defaultClusterIcon(clusterWeight),
  width: CLUSTER_WIDTH,
  height: CLUSTER_HEIGHT,
  anchorY: CLUSTER_HEIGHT,
  anchorX: CLUSTER_WIDTH * 0.5,
  id: `cluster-${clusterWeight}`
});

export const getLargestClusterSettings = () => ({ clusterWeight }: any) => ({
  url: largestClusterIcon(clusterWeight),
  width: LARGET_CLUSTER_WIDTH,
  height: LARGEST_CLUSTER_HEIGHT,
  anchorY: LARGEST_CLUSTER_HEIGHT,
  anchorX: LARGET_CLUSTER_WIDTH * 0.5,
  id: `large-cluster-${clusterWeight}`
});

const ICONS = {
  cluster: getClusterSettings(),
  largeCluster: getLargestClusterSettings(),
  place: () => ({
    url: placeActiveIcon,
    height: 152,
    width: 152,
    anchorY: 152,
    anchorX: 152 * 0.5,
    id: 'place'
  }),
  station1: getMarkerSettings(commonStationIcon, 'station1'),
  station2: getMarkerSettings(discountStationIcon, 'station2'),
  station4: getMarkerSettings(powerMaxStationIcon, 'station4'),
  station5: getMarkerSettings(economyStationIcon, 'station5'),
  stationFavourite1: getMarkerSettings(commonFavouriteStationIcon, 'stationFavourite1'),
  stationFavourite2: getMarkerSettings(discountFavouriteStationIcon, 'stationFavourite2'),
  stationFavourite4: getMarkerSettings(powerMaxFavouriteStationIcon, 'stationFavourite4'),
  stationFavourite5: getMarkerSettings(economyFavouriteStationIcon, 'stationFavourite5'),
  stationSelectedOnRoute1: getMarkerSelectedSettings(commonSelectedOnRouteIcon, 'stationSelectedOnRoute1'),
  stationSelectedOnRoute2: getMarkerSelectedSettings(discountSelectedOnRouteIcon, 'stationSelectedOnRoute2'),
  stationSelectedOnRoute4: getMarkerSelectedSettings(powerMaxSelectedOnRouteIcon, 'stationSelectedOnRoute4'),
  stationActive1: getActiveMarkerSettings(commonActiveStationIcon, 'stationActive1'),
  stationActive2: getActiveMarkerSettings(discountActiveStationIcon, 'stationActive2'),
  stationActive4: getActiveMarkerSettings(powerMaxActiveStationIcon, 'stationActive4'),
  stationActive5: getActiveMarkerSettings(economyActiveStationIconfrom, 'stationActive5'),
  stationActiveFavourite1: getActiveMarkerSettings(commonActiveFavouriteStationIcon, 'stationActiveFavourite1'),
  stationActiveFavourite2: getActiveMarkerSettings(discountActiveFavouriteStationIcon, 'stationActiveFavourite2'),
  stationActiveFavourite4: getActiveMarkerSettings(powerMaxActiveFavouriteStationIcon, 'stationActiveFavourite4'),
  stationActiveFavourite5: getActiveMarkerSettings(economyActiveFavouriteStationIconfrom, 'stationActiveFavourite5'),
  roadsideServiceSelectedOnRoute2: getMarkerSelectedSettings(roadPaymentPointSelectedServiceIcon, 'roadsideServiceSelectedOnRoute2'),
  roadsideServiceSelectedOnRoute3: getMarkerSelectedSettings(parkingSelectedServiceIcon, 'roadsideServiceSelectedOnRoute3'),
  roadsideServiceSelectedOnRoute4: getMarkerSelectedSettings(carWashSelectedServiceIcon, 'roadsideServiceSelectedOnRoute4'),
  roadsideServiceSelectedOnRoute5: getMarkerSelectedSettings(carServiceSelectedServiceIcon, 'roadsideServiceSelectedOnRoute5'),
  roadsideServiceSelectedOnRoute6: getMarkerSelectedSettings(convoySelectedServiceIcon, 'roadsideServiceSelectedOnRoute6'),
  roadsideServiceSelectedOnRoute7: getMarkerSelectedSettings(ferryboatSelectedServiceIcon, 'roadsideServiceSelectedOnRoute7'),
  roadsideServiceSelectedOnRoute8: getMarkerSelectedSettings(railwaySelectedServiceIcon, 'roadsideServiceSelectedOnRoute8'),
  roadsideServiceSelectedOnRoute9: getMarkerSelectedSettings(autoPartsStoreSelectedServiceIcon, 'roadsideServiceSelectedOnRoute9'),
  roadsideServiceSelectedOnRoute10: getMarkerSelectedSettings(cafeSelectedServiceIcon, 'roadsideServiceSelectedOnRoute10'),
  roadsideServiceSelectedOnRoute11: getMarkerSelectedSettings(truckWashSelectedServiceIcon, 'roadsideServiceSelectedOnRoute11'),
  roadsideServiceSelectedOnRoute12: getMarkerSelectedSettings(carWashSelectedServiceIcon, 'roadsideServiceSelectedOnRoute12'),
  roadsideService2: getMarkerSettings(roadPaymentPointServiceIcon, 'roadsideService2'),
  roadsideService3: getMarkerSettings(parkingServiceIcon, 'roadsideService3'),
  roadsideService4: getMarkerSettings(carWashServiceIcon, 'roadsideService4'),
  roadsideService5: getMarkerSettings(carServiceServiceIcon, 'roadsideService5'),
  roadsideService6: getMarkerSettings(convoyServiceIcon, 'roadsideService6'),
  roadsideService7: getMarkerSettings(ferryboatServiceIcon, 'roadsideService7'),
  roadsideService8: getMarkerSettings(railwayServiceIcon, 'roadsideService8'),
  roadsideService9: getMarkerSettings(autoPartsStoreServiceIcon, 'roadsideService9'),
  roadsideService10: getMarkerSettings(cafeServiceIcon, 'roadsideService10'),
  roadsideService11: getMarkerSettings(truckWashServiceIcon, 'roadsideService11'),
  roadsideService12: getMarkerSettings(carWashServiceIcon, 'roadsideService12'),
  roadsideServiceFavourite2: getMarkerSettings(roadPaymentPointServiceFavouriteIcon, 'roadsideServiceFavourite2'),
  roadsideServiceFavourite3: getMarkerSettings(parkingServiceFavouriteIcon, 'roadsideServiceFavourite3'),
  roadsideServiceFavourite4: getMarkerSettings(carWashServiceFavouriteIcon, 'roadsideServiceFavourite4'),
  roadsideServiceFavourite5: getMarkerSettings(carServiceServiceFavouriteIcon, 'roadsideServiceFavourite5'),
  roadsideServiceFavourite6: getMarkerSettings(convoyServiceFavouriteIcon, 'roadsideServiceFavourite6'),
  roadsideServiceFavourite7: getMarkerSettings(ferryboatServiceFavouriteIcon, 'roadsideServiceFavourite7'),
  roadsideServiceFavourite8: getMarkerSettings(railwayServiceFavouriteIcon, 'roadsideServiceFavourite8'),
  roadsideServiceFavourite9: getMarkerSettings(autoPartsStoreServiceFavouriteIcon, 'roadsideServiceFavourite9'),
  roadsideServiceFavourite10: getMarkerSettings(cafeServiceFavouriteIcon, 'roadsideServiceFavourite10'),
  roadsideServiceFavourite11: getMarkerSettings(truckWashServiceFavouriteIcon, 'roadsideServiceFavourite11'),
  roadsideServiceFavourite12: getMarkerSettings(carWashServiceFavouriteIcon, 'roadsideServiceFavourite12'),
  roadsideServiceActive2: getActiveMarkerSettings(roadPaymentPointActiveServiceIcon, 'roadsideServiceActive2'),
  roadsideServiceActive3: getActiveMarkerSettings(parkingActiveServiceIcon, 'roadsideServiceActive3'),
  roadsideServiceActive4: getActiveMarkerSettings(carWashActiveServiceIcon, 'roadsideServiceActive4'),
  roadsideServiceActive5: getActiveMarkerSettings(carServiceActiveServiceIcon, 'roadsideServiceActive5'),
  roadsideServiceActive6: getActiveMarkerSettings(convoyActiveServiceIcon, 'roadsideServiceActive6'),
  roadsideServiceActive7: getActiveMarkerSettings(ferryboatActiveServiceIcon, 'roadsideServiceActive7'),
  roadsideServiceActive8: getActiveMarkerSettings(railwayActiveServiceIcon, 'roadsideServiceActive8'),
  roadsideServiceActive9: getActiveMarkerSettings(autoPartsStoreActiveServiceIcon, 'roadsideServiceActive9'),
  roadsideServiceActive10: getActiveMarkerSettings(cafeActiveServiceIcon, 'roadsideServiceActive10'),
  roadsideServiceActive11: getActiveMarkerSettings(truckWashActiveServiceIcon, 'roadsideServiceActive11'),
  roadsideServiceActive12: getActiveMarkerSettings(carWashActiveServiceIcon, 'roadsideServiceActive12'),
  roadsideServiceActiveFavourite2: getActiveMarkerSettings(roadPaymentPointActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite3: getActiveMarkerSettings(parkingActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite4: getActiveMarkerSettings(carWashActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite5: getActiveMarkerSettings(carServiceActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite6: getActiveMarkerSettings(convoyActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite7: getActiveMarkerSettings(ferryboatActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite8: getActiveMarkerSettings(railwayActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite9: getActiveMarkerSettings(autoPartsStoreActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite10: getActiveMarkerSettings(cafeActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite11: getActiveMarkerSettings(truckWashActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite12: getActiveMarkerSettings(carWashActiveFavouriteServiceIcon),
} as Record<string, any>;

export const getIconSettings = (markerName: string, d: any) => (
  ICONS[markerName] ? ICONS[markerName](d) : ICONS.station1(d)
);
